"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _CircularProgress = _interopRequireDefault(require("@mui/material/CircularProgress"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Wrapper = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  min-height: 80px;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var Loader = function Loader(_ref) {
  var color = _ref.color,
    size = _ref.size,
    thickness = _ref.thickness,
    standalone = _ref.standalone;
  return standalone ? /*#__PURE__*/_react["default"].createElement(Wrapper, null, /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], {
    color: color,
    size: size,
    thickness: thickness
  })) : /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], {
    color: color,
    size: size,
    thickness: thickness
  });
};
Loader.propTypes = {
  color: _propTypes["default"].string,
  size: _propTypes["default"].number,
  thickness: _propTypes["default"].number,
  standalone: _propTypes["default"].bool
};
Loader.defaultProps = {
  color: 'inherit',
  size: 40,
  thickness: 3.6,
  standalone: false
};
var _default = exports["default"] = Loader;